{
	"asset": { "generator": "Khronos glTF Blender I/O v3.6.28", "version": "2.0" },
	"scene": 0,
	"scenes": [{ "name": "Scene", "nodes": [0] }],
	"nodes": [{ "mesh": 0, "name": "Cube" }],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.800000011920929, 0.800000011920929, 0.800000011920929, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [{ "attributes": { "POSITION": 0, "NORMAL": 1, "TEXCOORD_0": 2 }, "indices": 3, "material": 0 }]
		}
	],
	"accessors": [
		{ "bufferView": 0, "componentType": 5126, "count": 24, "max": [1, 1, 1], "min": [-1, -1, -1], "type": "VEC3" },
		{ "bufferView": 1, "componentType": 5126, "count": 24, "type": "VEC3" },
		{ "bufferView": 2, "componentType": 5126, "count": 24, "type": "VEC2" },
		{ "bufferView": 3, "componentType": 5123, "count": 36, "type": "SCALAR" }
	],
	"bufferViews": [
		{ "buffer": 0, "byteLength": 288, "byteOffset": 0, "target": 34962 },
		{ "buffer": 0, "byteLength": 288, "byteOffset": 288, "target": 34962 },
		{ "buffer": 0, "byteLength": 192, "byteOffset": 576, "target": 34962 },
		{ "buffer": 0, "byteLength": 72, "byteOffset": 768, "target": 34963 }
	],
	"buffers": [{ "byteLength": 840, "uri": "untitled.bin" }]
}
